'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.isEmpty = isEmpty;
exports.email = email;
exports.required = required;
exports.createValidator = createValidator;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _constants = require('./../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function join(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0]; // first error
  };
}

function isEmpty(value) {
  return undefined === value || null === value || '' === value;
}

function email(value) {
  if (!isEmpty(value) && !_constants.REGEXP_EMAIL.test(value)) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'invalid-email-address' });
  }
}

function required(value) {
  if (isEmpty(value)) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'required' });
  }
}

function createValidator(rules) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var errors = {};
    (0, _keys2.default)(rules).forEach(function (key) {
      // concat enables both functions and arrays of functions
      var rule = join([].concat(rules[key]));
      var error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/validation.js
 ** module id = 1245
 ** module chunks = 0
 **/